import React, { Component } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import Strings from "@my-dld/assets/strings";
import TenantActionSuccessPage from "../TenantActionSuccessPage";
import { TenantContractContext } from "@eres/ejari-core/contexts/TenantContractContext";

interface Props extends RoutedViewProps {

}


interface State {

}

class SubmitSuccess extends Component<Props, State> {
	static contextType = TenantContractContext;
	context!: React.ContextType<typeof TenantContractContext>;

	render() {
		const { contractResp } = this.context;
		return <TenantActionSuccessPage
			message={ Strings.submit_owner_pending }
			title={ Strings.create_new_contract }
			buttonTitle={ Strings.back_to_home }
			refreshProperty={ true }
			extra={ <div className="refn-box">
				{ Strings.contract_number }: <span>{ contractResp?.ContractNumber }</span>
			</div>
			}
			{ ...this.props }/>;
	}
}

export default SubmitSuccess;
